import { SpaceSm, SpaceMd, ColorGray500, ColorGray100, SpaceXs, FontWeightBold, ColorCostcoRed } from "@nxt-costco-com/forge-design-tokens";
const getListItemSx = (id) => ({
  backgroundColor: id === "signout" ? ColorGray100 : "inherit",
  borderBottom: `1px solid ${ColorGray500}`,
  padding: `${SpaceSm} 0 ${SpaceSm} ${SpaceMd}`
});
const ButtonSx = {
  "&:focus": {
    textDecoration: "none"
  },
  "&:hover": {
    fontWeight: FontWeightBold,
    textDecoration: "none"
  },
  alignItems: "center",
  color: "inherit",
  display: "flex",
  gap: SpaceXs,
  justifyContent: "flex-start",
  textDecoration: "none"
};
const LinkSx = {
  "&:hover": {
    textDecoration: "none"
  },
  alignItems: "center",
  color: "inherit",
  display: "flex",
  gap: SpaceXs,
  justifyContent: "flex-start",
  textDecoration: "none"
};
const TextSx = {
  ":hover": {
    fontWeight: "bold"
  }
};
const SkeltonContainerSx = {
  alignItems: "center",
  display: "flex",
  gap: SpaceXs,
  justifyContent: "flex-start",
  paddingRight: SpaceMd,
  width: "100%"
};
const iconStyles = {
  color: ColorCostcoRed,
  height: "22px",
  width: "22px"
};
export {
  ButtonSx,
  LinkSx,
  SkeltonContainerSx,
  TextSx,
  getListItemSx,
  iconStyles
};
